import messaging from '@/locales/es/messaging/messaging.locales';

export default {
    ...messaging,
};
